/* tslint:disable */
/* eslint-disable */
export enum Region {
  All = 'All',
  Eastern = 'Eastern',
  Midwest = 'Midwest',
  Southern = 'Southern',
  Western = 'Western'
}
